module.exports = __webpack_public_path__ + "static/media/book.78c7bf2e.jpg";